// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"8f03520f","197":"99235cb8","207":"a8e7d606","404":"ace6a46a","535":"6d4c19ce","652":"bf19eb75","694":"e51ceda6","725":"94ffb8c7","837":"a97261f4"}[chunkId] + ".chunk.js";
};